export const questions = {
  namespaced: true,
  state: {
    questions: [],
    answers: [],
    userSelectedAnswers: []
  },
  getters: {
    getQuestions (state) {
      return state.questions
    },
    getAnswers (state) {
      return state.answers
    },
    getUserSelectedAnswers (state) {
      return state.userSelectedAnswers
    }
  },
  actions: {
    onAddQuestions (context, questions) {
      context.commit('addQuestions', questions)
    },
    onAddAnswers (context, answers) {
      context.commit('addAnswers', answers)
    },
    onAddUserSelectedAnswers (context, answers) {
      context.commit('addUserSelectedAnswers', answers)
    }
  },
  mutations: {
    addQuestions (state, questions) {
      state.questions = questions
    },
    addAnswers (state, answers) {
      state.answers = answers
    },
    addUserSelectedAnswers (state, answers) {
      state.userSelectedAnswers = answers
    }
  }
}
